import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';

import ProgressMeter from './components/progress_meter';
import TextButton from './components/buttons/text_button';
import MediaIngest from './lib/media_ingest';
import util from './tools/util';

const styles = StyleSheet.create({
  uploaderProgressScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white',
    fontSize: '0.85em',
  },
  body: {
    flex: 1,
    alignSelf: 'stretch',
    padding: '2rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    marginTop: '0.5em',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    padding: '1em',
    border: '2px solid black',
    borderRadius: '0.5em',
  },
  scrollInner: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  title: {
    fontSize: '2em',
    fontWeight: 'bold',
  },
  sectionTitle: {
    marginTop: '0.5em',
    fontSize: '1.5em',
    fontWeight: 'bold',
  },
  button: {
    width: '10em',
    height: '2em',
  },
  doneView: {
    height: '3em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  summary: {
    height: '3em',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  summaryText: {
    color: 'black',
    fontSize: '1em',
    fontWeight: 'bold',
  },
  fileView: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  fileList: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  item: {
    alignSelf: 'stretch',
    height: '3em',
    paddingLeft: '1em',
    paddingRight: '1em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#eee',
  },
  oddItem: {
    backgroundColor: '#ddd',
  },
  path: {
    flex: 1,
  },
  size: {
    marginLeft: '1em',
    width: '5em',
    fontWeight: 'bold',
  },
  status: {
    marginLeft: '1em',
    width: '8em',
  },
  speed: {
    marginLeft: '1em',
    width: '6em',
    fontWeight: 'bold',
  },
  meterView: {
    marginLeft: '1em',
    width: '20em',
    flexDirection: 'row',
  },
  meter: {
    flex: 1,
    height: '1.6em',
    padding: '0.2em',
    backgroundColor: '#ccc',
    borderRadius: '10em',
    overflow: 'hidden',
  },
  error: {
    color: 'red',
    fontWeight: 'bold',
  },
  success: {
    color: 'green',
    fontWeight: 'bold',
  },
  logView: {
    height: '20em',
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  logTop: {
    marginTop: '1em',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logTitle: {
    fontSize: '1.5em',
    fontWeight: 'bold',
  },
  hideButton: {
    marginLeft: '1em',
    width: '10em',
    height: '2em',
  },
  showButton: {
    marginTop: '1em',
    width: '10em',
    height: '2em',
  },
});

type Props = {
  uploadOrg: any;
  uploadVolume: any;
  destDir: string;
  onRetry: () => void;
  onDone: () => void;
};
type State = {
  file_count: number;
  total_size: number;
  list: any;
  log: string;
  show_done: boolean;
};
export default class UploaderScreen extends React.PureComponent<Props, State> {
  state = {
    upload_org: '1',
    upload_volume: '1',
    file_count: 0,
    total_size: 0,
    log: '',
    list: null,
    show_done: false,
    show_log: false,
  };
  _log = '';
  componentDidMount() {
    MediaIngest.addChangeListener(this._onMediaChange);
  }
  componentWillUnmount() {
    MediaIngest.removeChangeListener(this._onMediaChange);
  }
  _onMediaChange = (reason, arg1, arg2) => {
    const item = arg1 && arg1.item_id ? arg1 : null;

    if (reason === 'start') {
      const { file_count, total_size } = arg1;
      const list = arg2.slice();
      this.setState({ file_count, total_size, list });
      this.log('start', { file_count, total_size });
    } else if (reason === 'done') {
      this.setState({ show_done: true });
      this.log('done');
    } else if (reason === 'item_progress') {
      this.log(reason, item.local_path, item.hash, item.progress);
    } else if (reason === 'item_update') {
      this.log(reason, item.local_path, item.hash, item.status);
    } else {
      if (item && arg2) {
        this.log(reason, item.local_path, item.hash, 'err:', arg2);
      } else if (item) {
        this.log(reason, item.local_path, item.hash);
      } else {
        this.log(reason, arg1, arg2);
      }
    }
    this.forceUpdate();
  };
  log = (...args) => {
    const s = util.argsToString(...args);
    const line = '[' + new Date().toUTCString() + '] ' + s;
    util.log(s);
    this._log += line + '\n';
    this.setState({ log: this._log });
  };
  _onShowLog = () => this.setState({ show_log: true });
  _onHideLog = () => this.setState({ show_log: false });
  render() {
    const { onDone } = this.props;
    const { show_log, list, log, show_done } = this.state;

    let done_buttons = null;
    if (show_done) {
      done_buttons = (
        <>
          <TextButton style={styles.button} text='Done' onPress={onDone} />
        </>
      );
    }
    let files = null;
    if (list) {
      const sorted = list.sort(_sortItem);
      files = sorted.map((item, i) => <Item key={i} odd={i % 2} item={item} />);
    }
    let log_view = null;
    if (show_log) {
      log_view = (
        <View style={styles.logView}>
          <View style={styles.logTop}>
            <Text style={styles.logTitle}>Log:</Text>
            <TextButton
              style={styles.hideButton}
              text='Hide'
              onPress={this._onHideLog}
            />
          </View>
          <ScrollView
            style={styles.scroller}
            contentContainerStyle={styles.scrollInner}
          >
            <View style={styles.log}>
              <pre>{log}</pre>
            </View>
          </ScrollView>
        </View>
      );
    } else {
      log_view = (
        <TextButton
          style={styles.showButton}
          text='Show Log'
          onPress={this._onShowLog}
        />
      );
    }

    return (
      <View style={styles.uploaderProgressScreen}>
        <View style={styles.body}>
          <Text style={styles.title}>ABT Uploader</Text>
          <View style={styles.doneView}>{done_buttons}</View>
          <View style={styles.fileView}>
            <Text style={styles.sectionTitle}>Files:</Text>
            <ScrollView
              style={styles.scroller}
              contentContainerStyle={styles.scrollInner}
            >
              <View style={styles.fileList}>{files}</View>
            </ScrollView>
          </View>
          {log_view}
        </View>
      </View>
    );
  }
}
function Item(props) {
  const { item, odd } = props;
  const {
    file,
    local_path,
    status,
    last_err,
    fatal_err,
    progress,
    skip,
    start_upload_time,
  } = item;

  let meter = null;
  let speed = '';
  if (status === 'uploading') {
    meter = <ProgressMeter style={styles.meter} fraction={progress} />;
    const delta_s = (Date.now() - start_upload_time) / 1000;
    const size = file.size * progress;
    const bps = (size / delta_s) * 8;
    speed = util.byteToString(bps) + 'ps';
  } else if (status === 'done' && !last_err && !fatal_err) {
    let text = 'Upload Complete';
    if (skip) {
      text += ' (skip)';
    }
    meter = <Text style={styles.success}>{text}</Text>;
  } else {
    let text = '';
    if (fatal_err) {
      text = 'Fatal Error: ' + fatal_err;
    } else if (last_err) {
      text = 'Last Error: ' + last_err;
    }
    meter = <Text style={styles.error}>{text}</Text>;
  }

  return (
    <View style={[styles.item, odd ? styles.oddItem : null]}>
      <Text style={styles.path}>{local_path}</Text>
      <Text style={styles.size}>{util.byteToString(file.size)}</Text>
      <Text style={styles.status}>{status}</Text>
      <Text style={styles.speed}>{speed}</Text>
      <View style={styles.meterView}>{meter}</View>
    </View>
  );
}

function _sortItem(a, b) {
  let ret;
  if (a.status === 'uploading' && b.status === 'uploading') {
    ret = b.item_id - a.item_id;
  } else if (a.status === 'uploading' && b.status !== 'uploading') {
    ret = -1;
  } else if (b.status === 'uploading' && a.status !== 'uploading') {
    ret = 1;
  } else if (a.fatal_err && !b.fatal_err) {
    ret = -1;
  } else if (b.fatal_err && !a.fatal_err) {
    ret = 1;
  } else {
    ret = b.last_updated - a.last_updated;
  }
  return ret;
}
const KB = 1024;
const MB = 1024 * KB;
const GB = 1024 * MB;

export function _mbps(bytes) {
  let ret;
  if (bytes > GB) {
    ret = `${(bytes / GB).toFixed(3)}Gb`;
  } else if (bytes > MB) {
    ret = `${(bytes / MB).toFixed(3)}Mb`;
  } else if (bytes > KB) {
    ret = `${(bytes / KB).toFixed(3)}Kb`;
  } else {
    ret = bytes + 'B';
  }
  return ret;
}
